import React from "react";

export const ThemeContext = React.createContext({ toggleColorMode: () => {} });
export const useThemeContext = () => React.useContext(ThemeContext);
